import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash;
        const sessionId = hash
            ? new URLSearchParams(hash.substring(1)).get("session_id")
            : null;

        if (!sessionId) {
            navigate("/admin", { replace: true, state: { authError: true } });
            return;
        }

        (async () => {
            try {
                const resp = await fetch(`${API}/auth/session`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ session_id: sessionId }),
                    credentials: "include",
                });
                if (!resp.ok) throw new Error(`session exchange failed: ${resp.status}`);
                const user = await resp.json();
                navigate("/admin", { replace: true, state: { user } });
            } catch (e) {
                navigate("/admin", { replace: true, state: { authError: true } });
            }
        })();
    }, [navigate]);

    return <div className="min-h-screen bg-obsidian" data-testid="auth-callback" />;
};

export default AuthCallback;
